export const aciTvAccessories = {
    iconName: 'tv-accessories',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 25' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M5.177 7.738A.26.26 0 004.916 8v9.702a.26.26 0 00.26.261h15.6a.26.26 0 00.26-.261v-6.282a.5.5 0 111 0v6.282a1.261 1.261 0 01-1.26 1.261h-15.6a1.26 1.26 0 01-1.26-1.261V7.999a1.26 1.26 0 011.26-1.26h9.182a.5.5 0 110 1H5.177z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M8.825 18.014a.5.5 0 01.224.67l-.951 1.903a.5.5 0 11-.895-.447l.951-1.903a.5.5 0 01.671-.223zM17.128 18.014a.5.5 0 01.67.223l.952 1.903a.5.5 0 01-.894.447l-.952-1.902a.5.5 0 01.224-.671zM16.488 10.166a3.372 3.372 0 114.77-4.768 3.372 3.372 0 01-4.77 4.768zm.707-.707a2.372 2.372 0 113.354-3.354 2.372 2.372 0 01-3.354 3.354z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M18.873 6.023a.5.5 0 01.5.5v2.519a.5.5 0 11-1 0V6.523a.5.5 0 01.5-.5z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M17.113 7.781a.5.5 0 01.5-.5h2.518a.5.5 0 010 1h-2.518a.5.5 0 01-.5-.5z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
